import { MdOutlineContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import styled from "styled-components";

const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: 1.25;
  text-align: left;
  cursor: pointer;
  transition: color 160ms ease;

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    color: var(--color-main);
    outline: none;
  }

  &:disabled {
    cursor: default;
    opacity: 1;
  }

  .copy-icon {
    flex: 0 0 auto;
    font-size: 14px;
  }

  .copy-text {
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .copy-label {
    color: inherit;
    font-size: inherit;
  }
`;

const copyWithFallback = (value) => {
  const textArea = document.createElement("textarea");
  textArea.value = value;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(textArea);
  return copied;
};

const CopyableShipmentValue = ({ label, value, className }) => {
  const displayValue = value === null || value === undefined || value === "" ? "---" : String(value);
  const canCopy = displayValue !== "---";

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!canCopy) return;

    try {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(displayValue);
        } catch {
          if (!copyWithFallback(displayValue)) throw new Error("Clipboard unavailable");
        }
      } else if (!copyWithFallback(displayValue)) {
        throw new Error("Clipboard unavailable");
      }

      toast.success(`${label} panoya kopyalandı.`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
      });
    } catch {
      toast.error("Panoya kopyalanamadı.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        pauseOnFocusLoss: false,
      });
    }
  };

  return (
    <CopyButton
      type="button"
      className={className}
      onClick={handleCopy}
      disabled={!canCopy}
      title={canCopy ? `${label} bilgisini kopyala` : `${label} bilgisi bulunmuyor`}
    >
      <MdOutlineContentCopy className="copy-icon" aria-hidden="true" />
      <span className="copy-text">
        <span className="copy-label">{label}: </span>
        {displayValue}
      </span>
    </CopyButton>
  );
};

export default CopyableShipmentValue;
